module.exports = __webpack_public_path__ + "img/UNDET.d4499c03.jpg";